module.exports = __webpack_public_path__ + "static/media/brownroom.adc830fa.png";